/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsslSearchRequestBody } from '|api/commons';
import { PageWorkflowTriggerEventDto } from '../../models/page-workflow-trigger-event-dto';

export interface AutomatedProcessSearchTriggerEvents$Params {
  
    /**
     * Search API request body.
     */
    body?: EsslSearchRequestBody|null|undefined
}

export function automatedProcessSearchTriggerEvents(http: HttpClient, rootUrl: string, params?: AutomatedProcessSearchTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<PageWorkflowTriggerEventDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessSearchTriggerEvents.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageWorkflowTriggerEventDto>;
    })
  );
}

automatedProcessSearchTriggerEvents.PATH = '/automated-process/workflow-trigger/trigger-event/search-api';